"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.soundsMuted = exports.MUTE_SOUNDS = void 0;
exports.MUTE_SOUNDS = 'MUTE_SOUNDS';
function soundsMuted() {
    var query = new URLSearchParams(window.location.search);
    return !!query.get('mute') || !!localStorage.getItem('soundsMuted');
}
exports.soundsMuted = soundsMuted;
